
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "ember-cli-typescript/-embroider-implicit-modules.js";
import "ember-auto-import/-embroider-implicit-modules.js";
import "ember-cli-htmlbars/-embroider-implicit-modules.js";
import "ember-cli-sass/-embroider-implicit-modules.js";
import "@market/ember/-embroider-implicit-modules.js";
import "ember-window-mock/-embroider-implicit-modules.js";
import "@glimmer/tracking/-embroider-implicit-modules.js";
import "@square/dashboard-translations/-embroider-implicit-modules.js";
import "@glimmer/component/-embroider-implicit-modules.js";
import "ember-concurrency/-embroider-implicit-modules.js";
import "ember-copy/-embroider-implicit-modules.js";
import "@square/dashboard-data/-embroider-implicit-modules.js";
import "@square/dashboard-protos/-embroider-implicit-modules.js";
import "@square/dashboard-utilities/-embroider-implicit-modules.js";
import "@square/ember-features/-embroider-implicit-modules.js";
